import { Link } from "react-router-dom";
import { ChevronRight, MapPin, Zap, CalendarDays } from "lucide-react";

function WorkRecordListItem({ item }) {
  const statusLabel = item.measure ? "진행중" : "종료";
  const mainTeal = "rgb(0, 224, 198)";

  return (
    <Link
      to={`/workrecord/get/${item.workRecordId}`}
      className="block bg-white border border-gray-100 rounded-2xl p-5 mb-4 transition-all active:scale-[0.98] active:bg-gray-50 shadow-sm"
    >
      {/* 상단: 상태 및 날짜 */}
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-1.5 text-gray-400">
          <CalendarDays className="w-3.5 h-3.5" />
          <span className="text-sm font-medium">{item.workRecordDate}</span>
        </div>
        <span
          className={`text-xs font-bold px-2.5 py-1 rounded-lg ${
            item.measure
              ? "bg-teal-50 text-[rgb(0,224,198)] border border-teal-100"
              : "bg-gray-100 text-gray-500"
          }`}
        >
          {statusLabel}
        </span>
      </div>

      {/* 중단: 코스 정보 (글씨 크게) */}
      <div className="mb-4">
        <h3
          className={`text-xl font-bold leading-tight ${item.courseName && item.courseName.trim() !== ""
              ? "text-gray-900"
              : "text-gray-400"
          }`}
        >
          {item.courseName && item.courseName.trim() !== "" ? item.courseName : "코스 생성중..."}

          {item.battleName && (
            <span className="inline-block bg-blue-50 text-blue-600 text-xs px-2 py-0.5 rounded-md font-bold ml-2 align-middle">
              {item.battleName}
            </span>
          )}
        </h3>
      </div>

      {/* 하단: 주요 수치 (아이콘과 글씨 확대) */}
      <div className="flex items-center gap-6 pt-3 border-t border-gray-50">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-teal-50 rounded-full flex items-center justify-center">
            <MapPin className="w-5 h-5 text-[rgb(0,224,198)]" />
          </div>
          <div className="flex flex-col">
            <span className="text-xs text-gray-400 font-bold uppercase tracking-tighter">
              Distance
            </span>
            <span className="text-lg font-black text-gray-800">
              {item.distance} <small className="text-xs font-bold">km</small>
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-orange-50 rounded-full flex items-center justify-center">
            <Zap className="w-5 h-5 text-orange-400" />
          </div>
          <div className="flex flex-col">
            <span className="text-xs text-gray-400 font-bold uppercase tracking-tighter">
              Speed
            </span>
            <span className="text-lg font-black text-gray-800">
              {item.avgSpeed} <small className="text-xs font-bold">km/h</small>
            </span>
          </div>
        </div>

        <div className="ml-auto">
          <ChevronRight className="w-6 h-6 text-gray-300" />
        </div>
      </div>
    </Link>
  );
}

export default WorkRecordListItem;
